/* WeldRda (travail 21): cart drawer extras. Loaded by snippets/cart-drawer.liquid on every page.
   1. Veil: while the cart is open on a computer, the page behind is dimmed and blurred (CSS in wr-dep.css);
      a click on it closes the cart.
   2. "Vous aimerez aussi" in the drawer: arrows scroll the row; the "+" of a card opens a quick panel
      (sections/wr-quick-view, loaded on demand) above the drawer: photos 1 / N, colours, sizes (never
      pre-selected), Ajouter au panier. The add uses the theme cart events (same as assets/wr.js), so the
      drawer lines, the total and the check on the card update by themselves. */
(function () {
'use strict';
if (window.__wrCartJs) return;
window.__wrCartJs = true;

function formatDH(cents) {
var n = Math.round(cents / 100);
return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' DH';
}
function routeRoot() {
return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}
function readJSON(el) {
try { return JSON.parse(el ? el.textContent : '[]'); } catch (e) { return []; }
}
var evPromise = null;
function cartEvents() {
if (evPromise) return evPromise;
evPromise = new Promise(function (resolve) {
if (window.__wrCartLinesEv) { resolve(window.__wrCartLinesEv); return; }
var done = false;
function finish() { if (done) return; done = true; resolve(window.__wrCartLinesEv || null); }
window.addEventListener('wr:cart-events', finish, { once: true });
var s = document.createElement('script');
s.type = 'module';
s.textContent = "import { CartLinesUpdateEvent } from '@shopify/events'; window.__wrCartLinesEv = CartLinesUpdateEvent; window.dispatchEvent(new Event('wr:cart-events'));";
document.head.appendChild(s);
setTimeout(finish, 4000);
});
return evPromise;
}
function drawerEl() { return document.getElementById('cart-drawer'); }

/* 1. Veil behind the open cart (computers; phones use the dialog backdrop) */
function initVeil() {
if (document.querySelector('.wr-cart-veil')) return;
var v = document.createElement('div');
v.className = 'wr-cart-veil';
v.setAttribute('aria-hidden', 'true');
v.addEventListener('click', function () {
var d = drawerEl();
if (d && typeof d.close === 'function') d.close();
});
document.body.appendChild(v);
}

/* 2a. Arrows of the drawer row */
function scrollRow(btn, dir) {
var sec = btn.closest('.wr-reco');
var row = sec ? sec.querySelector('.wr-reco__row') : null;
if (!row) return;
row.scrollBy({ left: dir * Math.max(120, row.clientWidth * 0.8), behavior: 'smooth' });
}

/* 2b. Quick panel */
var cache = {};
var qv = null;
function panel() {
var d = drawerEl();
var host = d ? d.querySelector('dialog') : null;
if (qv && qv.isConnected && (!host || host.contains(qv))) return qv;
qv = document.createElement('dialog');
qv.className = 'wr-qvd';
qv.setAttribute('aria-label', 'Aperçu de la pièce');
qv.addEventListener('click', function (e) {
if (e.target === qv) { e.stopPropagation(); closePanel(); }
});
qv.addEventListener('keydown', function (e) {
if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closePanel(); }
});
qv.addEventListener('cancel', function (e) { e.preventDefault(); closePanel(); });
/* Inside the drawer dialog: the drawer keeps focus there and knows a nested dialog is open. */
(host || document.body).appendChild(qv);
return qv;
}
function closePanel() {
if (!qv || !qv.open) return;
qv.classList.add('is-closing');
setTimeout(function () { qv.classList.remove('is-closing'); if (qv.open) qv.close(); }, 180);
}
function openQuick(handle, btn) {
var d = panel();
d.innerHTML = '<div class="wr-qv wr-qv--loading"><div class="wr-qv__head"><span class="wr-qv__head-title"></span><button type="button" class="wr-qv__close" data-qv-close aria-label="Fermer">×</button></div><div class="wr-qv__spin" aria-label="Chargement"></div></div>';
bindClose(d);
if (!d.open) d.showModal();
var url = routeRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=wr-quick-view';
var p = cache[handle] ? Promise.resolve(cache[handle]) : fetch(url, { headers: { 'Accept': 'text/html' } }).then(function (r) {
if (!r.ok) throw new Error('HTTP ' + r.status);
return r.text();
});
p.then(function (html) {
cache[handle] = html;
var doc = new DOMParser().parseFromString(html, 'text/html');
var root = doc.querySelector('[data-qv]');
if (!root) throw new Error('no panel');
d.innerHTML = '';
d.appendChild(document.importNode(root, true));
initPanel(d.querySelector('[data-qv]'), handle, btn);
}).catch(function () {
closePanel();
window.location.href = routeRoot() + 'products/' + encodeURIComponent(handle);
});
}
function bindClose(d) {
d.querySelectorAll('[data-qv-close]').forEach(function (b) { b.addEventListener('click', closePanel); });
}
function initPanel(root, handle, opener) {
bindClose(root);
var variants = readJSON(root.querySelector('[data-qv-variants]'));
var ci = parseInt(root.getAttribute('data-color-index'), 10);
var si = parseInt(root.getAttribute('data-size-index'), 10);
var needSize = root.hasAttribute('data-require-size');
var fieldsets = root.querySelectorAll('.wr-opt');
var track = root.querySelector('[data-qv-track]');
var slides = track ? Array.prototype.slice.call(track.children) : [];
var count = root.querySelector('[data-qv-count]');
var nav = root.querySelector('[data-qv-nav]');
var addBtn = root.querySelector('[data-qv-add]');
var label = root.querySelector('[data-qv-label]');
var msg = root.querySelector('[data-qv-msg]');
var priceEl = root.querySelector('[data-qv-price]');
var cmpEl = root.querySelector('[data-qv-compare]');
var lastColor = null;
var busy = false;
function shown() { return slides.filter(function (s) { return !s.hidden; }); }
function setCount() {
if (!track || !count) return;
var list = shown();
var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
count.textContent = Math.min(list.length, i + 1) + ' / ' + list.length;
if (nav) nav.hidden = list.length < 2;
}
function filterColor(c) {
var has = slides.some(function (s) { return s.getAttribute('data-color') === c; });
slides.forEach(function (s) {
var sc = s.getAttribute('data-color');
s.hidden = !(!has || sc === '*' || sc === c);
});
if (track) track.scrollTo({ left: 0, behavior: 'auto' });
setCount();
}
function selected() {
var out = [];
Array.prototype.forEach.call(fieldsets, function (fs) {
var c = fs.querySelector('input[type=radio]:checked');
out[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
});
return out;
}
function match(opts) {
for (var i = 0; i < variants.length; i++) {
var v = variants[i], ok = true;
for (var k = 0; k < opts.length; k++) { if (opts[k] != null && v.options[k] !== opts[k]) { ok = false; break; } }
if (ok) return v;
}
return null;
}
function markSizes(opts) {
Array.prototype.forEach.call(fieldsets, function (fs) {
var idx = parseInt(fs.getAttribute('data-option-index'), 10);
fs.querySelectorAll('input[type=radio]').forEach(function (r) {
var test = opts.slice(); test[idx] = r.value;
var any = variants.some(function (v) {
for (var k = 0; k < test.length; k++) { if (test[k] != null && v.options[k] !== test[k]) return false; }
return v.available;
});
var lab = fs.querySelector('label[for="' + r.id + '"]');
if (lab && lab.classList.contains('wr-size')) lab.classList.toggle('is-unavailable', !any);
});
});
}
function current() {
var opts = selected();
var missing = needSize && si >= 0 && opts[si] == null;
var v = variants.length && !fieldsets.length ? variants[0] : match(opts);
return { opts: opts, v: v, missing: missing };
}
function update() {
var st = current();
Array.prototype.forEach.call(fieldsets, function (fs) {
var c = fs.querySelector('input[type=radio]:checked');
var lab = fs.querySelector('[data-option-label]');
if (lab && c) lab.textContent = c.value;
});
if (ci >= 0 && st.opts[ci] != null && st.opts[ci] !== lastColor) {
lastColor = st.opts[ci];
filterColor(lastColor);
}
markSizes(st.opts);
if (st.v && priceEl) {
priceEl.textContent = formatDH(st.v.price);
if (cmpEl) {
if (st.v.compare && st.v.compare > st.v.price) { cmpEl.textContent = formatDH(st.v.compare); cmpEl.hidden = false; }
else cmpEl.hidden = true;
}
}
if (busy) return;
if (st.missing) { addBtn.disabled = true; label.textContent = 'Choisissez votre taille'; }
else if (!st.v || !st.v.available) { addBtn.disabled = true; label.textContent = 'Épuisé'; }
else { addBtn.disabled = false; label.textContent = 'Ajouter au panier'; }
}
function showMsg(t) { if (!msg) return; msg.textContent = t || ''; msg.hidden = !t; }
Array.prototype.forEach.call(fieldsets, function (fs) { fs.addEventListener('change', update); });
if (track) {
var raf;
track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(setCount); }, { passive: true });
}
var prev = root.querySelector('[data-qv-prev]');
var next = root.querySelector('[data-qv-next]');
if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
if (ci >= 0) { lastColor = selected()[ci]; if (lastColor != null) filterColor(lastColor); else setCount(); } else setCount();
update();

addBtn.addEventListener('click', function () {
var st = current();
if (busy || st.missing || !st.v || !st.v.available) return;
busy = true;
addBtn.disabled = true;
label.textContent = 'Ajout…';
showMsg('');
var r = routeRoot();
var ids = [];
document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { ids.push(el.getAttribute('data-section-id')); });
var body = { items: [{ id: st.v.id, quantity: 1 }] };
if (ids.length) body.sections = ids.join(',');
var Ev = null, deferred = null, added = false;
cartEvents().then(function (C) {
Ev = C || null;
if (Ev) {
deferred = Ev.createPromise();
root.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: [{ merchandiseId: String(st.v.id), quantity: 1 }], promise: deferred.promise }));
}
return fetch(r + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: JSON.stringify(body) });
})
.then(function (res) { return res.json(); })
.then(function (res) {
var failed = !!(res && res.status);
if (!failed) added = true;
return fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).then(function (cart) {
if (deferred) {
deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: 'wr-quick-view', itemCount: 1, productId: root.getAttribute('data-product-id') || '', sections: failed ? undefined : res.sections, didError: failed } });
}
if (failed) { showMsg(res.description || res.message || 'Impossible d’ajouter cet article.'); return; }
document.querySelectorAll('[data-wr-quick="' + handle + '"]').forEach(function (b) {
var card = b.closest('.wr-dcard');
if (card) card.classList.add('is-added');
});
closePanel();
if (!deferred) window.location.href = r + 'cart';
});
})
.catch(function (err) {
if (deferred) { try { deferred.reject(err); } catch (e) {} }
if (added) window.location.href = r + 'cart';
else showMsg('Connexion impossible. Vérifiez votre internet et réessayez.');
})
.then(function () { busy = false; if (root.isConnected) update(); });
});
}

document.addEventListener('click', function (e) {
var q = e.target.closest ? e.target.closest('[data-wr-quick]') : null;
if (q) { e.preventDefault(); openQuick(q.getAttribute('data-wr-quick'), q); return; }
var pv = e.target.closest ? e.target.closest('[data-reco-prev]') : null;
if (pv) { scrollRow(pv, -1); return; }
var nx = e.target.closest ? e.target.closest('[data-reco-next]') : null;
if (nx) { scrollRow(nx, 1); }
});
/* The cart closing also closes the quick panel. */
document.addEventListener('theme-drawer:close', function () { if (qv && qv.open) qv.close(); });

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVeil);
else initVeil();
})();
